import React from 'react';
import DynamicForm from 'components/DynamicForm';

const Step2FormDetails = ({
  selectedCategory,
  dynamicFormSchema,
  handleFormSubmit,
  isSubmitting,
  rubricData,
}) => {
  return (
    <div className="bg-white rounded-2xl shadow-smdd-card border border-gray-300 p-8">
      <div className="flex items-center mb-6">
        <div className="w-8 h-8 bg-red-smdd rounded-full flex items-center justify-center mr-4">
          <span className="text-white text-sm font-bold">2</span>
        </div>
        <div>
          <h2 className="text-2xl font-baijamjuree font-extrabold text-black">
            Submission Details
          </h2>
          <p className="text-gray-700 mt-1">
            Complete your <span className="font-bold">{selectedCategory}</span>{' '}
            application
          </p>
        </div>
      </div>

      {dynamicFormSchema && (
        <div className="ml-12 mr-12">
          <DynamicForm
            schema={dynamicFormSchema}
            onSubmit={handleFormSubmit}
            isSubmitting={isSubmitting}
            category={selectedCategory}
            rubricData={rubricData}
          />
        </div>
      )}
    </div>
  );
};

export default Step2FormDetails;
